import {Component} from '@angular/core';

@Component({
  selector: 'ctv-forbidden',
  template: `Forbidden`,
})
export class ForbiddenComponent {

  constructor() {
  }


}
